// style.ts
import styled from 'styled-components';

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
`;

export const ModalBody = styled.div`
  font-size: 14px;
  color: #333;
`;

export const ModalFooter = styled.div`
  padding: 10px 16px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #ccc;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
`;

export const ActionButton = styled.button`
  padding: 8px 16px;
  margin-left: 10px;
  border: none;
  background-color: #007bff;
  color: white;
  font-weight: 500;
  cursor: pointer;
  border-radius: 4px;
  &:hover {
    background-color: #0056b3;
  }
`;
